export const delayAfterSuccessfulCopy = 5000;